import React from 'react';
import { Clock, FileText, Send, TrendingUp, Users } from 'lucide-react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

interface SettingsTabsListProps {
  tabsWithChanges: Set<string>;
}

export const SettingsTabsList: React.FC<SettingsTabsListProps> = ({ tabsWithChanges }) => (
  <TabsList className="grid w-full grid-cols-6 lg:w-auto lg:inline-flex">
    <TabsTrigger value="working-hours" className="gap-2">
      <Clock className="h-4 w-4" />
      Working Hours & Policies
      {tabsWithChanges.has('working-hours') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
    <TabsTrigger value="submissions-deadlines" className="gap-2">
      <Send className="h-4 w-4" />
      Submissions & Deadlines
      {tabsWithChanges.has('submissions-deadlines') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
    <TabsTrigger value="general" className="gap-2">
      <FileText className="h-4 w-4" />
      Time Entry Rules
      {tabsWithChanges.has('general') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
    <TabsTrigger value="overtime" className="gap-2">
      <Clock className="h-4 w-4" />
      Work Type
      {tabsWithChanges.has('overtime') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
    <TabsTrigger value="utilisation" className="gap-2">
      <TrendingUp className="h-4 w-4" />
      Utilisation
      {tabsWithChanges.has('utilisation') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
    <TabsTrigger value="on-behalf-of" className="gap-2">
      <Users className="h-4 w-4" />
      On Behalf Of
      {tabsWithChanges.has('on-behalf-of') && (
        <span className="ml-1 h-2 w-2 rounded-full" style={{ backgroundColor: 'var(--warning-500)' }} aria-label="Unsaved changes" />
      )}
    </TabsTrigger>
  </TabsList>
);
